import { datadogRum } from '@datadog/browser-rum';
import { UserRole } from '../CommonSelectors/CommonArea.types';

const ADVISOR_ROLE_NUMBER = 2;

const ROLES_MAP = ['Guest', 'Client', 'Adviser', 'Administrator', 'EmployerRepresentative'];

interface ApplicationSettings {
  applicationId: string;
  clientToken: string;
  site: string;
  env: string;
  version: string;
}

interface UserSettings {
  userId: string;
  role: UserRole;
  orionFirmId: string | null;
  organizationId: string | null;
  organizationName: string | null;
  orionUserId: string | null;
  isOrionClient?: boolean;
  isPrint?: boolean;
  isConsumer?: boolean;
  previewAdvisorId?: string;
}
export const initDatadog = (
  applicationSettings: ApplicationSettings,
  userSettings: UserSettings,
) => {
  const { env, ...restApplicationSettings } = applicationSettings;

  datadogRum.init({
    env: `op-${env}`,
    sampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackInteractions: true,
    service: 'orion-planning-web',
    allowedTracingOrigins: [
      /https:\/\/.*\.advizr\.com/,
      /http:\/\/.*\.advizr\.com/,
      /https:\/\/(?:.*-)?advizr-document-vault\.s3\.amazonaws\.com/,
    ],
    ...restApplicationSettings,
  });

  const {
    userId,
    role,
    isPrint,
    isConsumer,
    isOrionClient,
    previewAdvisorId,
    ...restUserSettings
  } = userSettings;

  const getPreviewInfo = () => {
    if (isConsumer && role === ADVISOR_ROLE_NUMBER) {
      return { isPreviewMode: 'Yes', previewAdvisorId };
    }
    return {};
  };

  const getOrionClientInfo = () => {
    if (isOrionClient !== undefined) {
      return { isOrionClient: isOrionClient ? 'Yes' : 'No' };
    }
    return {};
  };

  datadogRum.setUser({
    id: userId,
    role: ROLES_MAP[role],
    ...getOrionClientInfo(),
    ...getPreviewInfo(),
    ...(isPrint ? { isPrint: 'Yes' } : {}),
    ...restUserSettings,
  });
};
